export const getUsernameWithoutPrefix = (username?: string): string => {
    if (!username) {
        return "";
    }

    const [usernameWithoutPrefix] = username.split("\\").reverse();

    return usernameWithoutPrefix;
};
